import React from "react";
import { Admin, Resource } from "react-admin";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  Sms,
  People,
  PictureAsPdf,
  Tag,
  Class,
  Brush,
  Description,
  Widgets,
  NotificationsActive,
  Groups,
  AccountBox,
  Diversity3,
  Work,
  Business,
  Face,
  Payments,
  AccountBalanceWallet,
} from "@mui/icons-material/index.js";

import Pages from "./pages/index.js";
import Providers from "./providers/index.js";
import "./styles.scss";
export const App = () => {
  if (window.location.href.includes("/admin/")) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/admin/*" element={<Pages.Block.BlockPreview />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <Admin
      authProvider={Providers.authProvider}
      dataProvider={Providers.dataProvider()}
      i18nProvider={Providers.i18nProvider}
      disableTelemetry
    >
      <Resource
        name="Admin"
        list={Pages.Admin.List}
        show={Pages.Admin.Show}
        edit={Pages.Admin.Edit}
        icon={AccountBox}
      />
      <Resource
        name="Client"
        list={Pages.Client.List}
        show={Pages.Client.Show}
        edit={Pages.Client.Edit}
        create={Pages.Client.Create}
        icon={People}
      />
      <Resource
        name="Merchant"
        create={Pages.Merchant.Create}
        list={Pages.Merchant.List}
        show={Pages.Merchant.Show}
        edit={Pages.Merchant.Edit}
        icon={Diversity3}
      />
      <Resource
        name="Brand"
        list={Pages.Brand.List}
        show={Pages.Brand.Show}
        edit={Pages.Brand.Edit}
        create={Pages.Brand.Create}
        icon={Work}
      />
      <Resource
        name="PaymentGateway"
        list={Pages.PaymentGateway.List}
        show={Pages.PaymentGateway.Show}
        edit={Pages.PaymentGateway.Edit}
        create={Pages.PaymentGateway.Create}
        icon={Work}
      />
      <Resource
        name="MerchantPaymentGateway"
        list={Pages.MerchantPaymentGateway.List}
        show={Pages.MerchantPaymentGateway.Show}
        edit={Pages.MerchantPaymentGateway.Edit}
        create={Pages.MerchantPaymentGateway.Create}
        icon={Payments}
      />
      <Resource
        name="BrandMerchant"
        list={Pages.BrandMerchant.List}
        show={Pages.BrandMerchant.Show}
        edit={Pages.BrandMerchant.Edit}
        create={Pages.BrandMerchant.Create}
        icon={Groups}
      />
      <Resource
        name="SmsService"
        list={Pages.SmsService.List}
        edit={Pages.SmsService.Edit}
        create={Pages.SmsService.Create}
        icon={Sms}
      />
      <Resource
        name="Category"
        list={Pages.Category.List}
        show={Pages.Category.Show}
        edit={Pages.Category.Edit}
        create={Pages.Category.Create}
        icon={Class}
      />
      <Resource
        name="Design"
        list={Pages.Design.List}
        show={Pages.Design.Show}
        edit={Pages.Design.Edit}
        create={Pages.Design.Create}
        icon={Brush}
      />
      <Resource
        name="Page"
        create={Pages.Page.Create}
        show={Pages.Page.Show}
        list={Pages.Page.List}
        edit={Pages.Page.Edit}
        icon={Description}
      />
      <Resource
        name="Block"
        list={Pages.Block.List}
        show={Pages.Block.Show}
        edit={Pages.Block.Edit}
        create={Pages.Block.Create}
        icon={Widgets}
      />
      <Resource
        name="Tag"
        list={Pages.Tag.List}
        show={Pages.Tag.Show}
        edit={Pages.Tag.Edit}
        create={Pages.Tag.Create}
        icon={Tag}
      />
      <Resource
        name="File"
        list={Pages.File.List}
        show={Pages.File.Show}
        create={Pages.File.Create}
        icon={PictureAsPdf}
      />
      <Resource
        name="Promotion"
        list={Pages.Promotion.List}
        show={Pages.Promotion.Show}
        edit={Pages.Promotion.Edit}
        create={Pages.Promotion.Create}
        icon={NotificationsActive}
      />
      <Resource
        name="Company"
        list={Pages.Company.List}
        show={Pages.Company.Show}
        icon={Business}
      />
      <Resource
        name="Manager"
        list={Pages.Manager.List}
        create={Pages.Manager.Create}
        show={Pages.Manager.Show}
        icon={Face}
      />
      <Resource
        name="GasBrand"
        list={Pages.GasBrand.List}
        create={Pages.GasBrand.Create}
        show={Pages.GasBrand.Show}
        edit={Pages.GasBrand.Edit}
        icon={Face}
      />

      <Resource
        name="GasBrandMerchant"
        list={Pages.GasBrandMerchant.List}
        create={Pages.GasBrandMerchant.Create}
        show={Pages.GasBrandMerchant.Show}
        edit={Pages.GasBrandMerchant.Edit}
        icon={Face}
      />
      <Resource
        name="Trunc"
        list={Pages.Trunc.List}
        show={Pages.Trunc.Show}
        icon={AccountBalanceWallet}
      />
    </Admin>
  );
};
